module.exports = __webpack_public_path__ + "media/images/emoticons/shine-3f83aa4d7931f06b06d4e0ac95f950df.gif";